import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetDashboardsCB} from "../../ope/dashboard/GetDashboardsCB";
import {GetAllUserDashboardsCB} from "../../ope/dashboard/GetAllUserDashboardsCB";
import {GetAllUserDashboardWidgetsCB} from "../../ope/dashboard/GetAllUserDashboardWidgetsCB";
import {PutDashboardCB} from "../../ope/dashboard/PutDashboardCB";
import {DelDashboardCB} from "../../ope/dashboard/DelDashboardCB";
import {GetDashboardWidgetsCB} from "../../ope/dashboard/GetDashboardWidgetsCB";
import {PutDashboardWidgetCB} from "../../ope/dashboard/PutDashboardWidgetCB";
import {DelDashboardWidgetCB} from "../../ope/dashboard/DelDashboardWidgetCB";
import {GetWidgetsCB} from "../../ope/dashboard/GetWidgetsCB";
import {ShareDashboardCB} from "../../ope/dashboard/ShareDashboardCB";
import {ValidateShareDraftCB} from "../../ope/dashboard/ValidateShareDraftCB";

@Injectable({
  providedIn: 'root'
})
export class DashboardOpeService extends BaseOPEService {

  public getDashboards(cb: GetDashboardsCB): Promise<any> {
    return this.execOPE(cb);
  }

  // Impersonation-aware variants: same data, but for the dashboards of another user too.
  public getAllUserDashboards(cb: GetAllUserDashboardsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getAllUserDashboardWidgets(cb: GetAllUserDashboardWidgetsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putDashboard(cb: PutDashboardCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delDashboard(cb: DelDashboardCB): Promise<any> {
    return this.execOPE(cb);
  }

  public shareDashboard(cb: ShareDashboardCB): Promise<any> {
    return this.execOPE(cb);
  }

  public validateShareDraft(cb: ValidateShareDraftCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getDashboardWidgets(cb: GetDashboardWidgetsCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putDashboardWidget(cb: PutDashboardWidgetCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delDashboardWidget(cb: DelDashboardWidgetCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getWidgets(cb: GetWidgetsCB): Promise<any> {
    return this.execOPE(cb);
  }

}
